import { uniqueClientId } from '@modules/application/apollo-client';
import { getFromLocalStorage } from '@utils/storageUtils';
import dayjs from 'dayjs';
import { getTenantIdentifier } from '../utils/getTenantIdentifier';

export class ApiError extends Error {
  public readonly errorCode: number;

  constructor(errorCode: number, message?: string) {
    super(message);
    this.errorCode = errorCode;
  }
}

export class TenantMissingError extends Error {
}

export class DomainError extends Error {
  public readonly errors: unknown[];

  constructor(message?: string, errors?: unknown[]) {
    super(message);
    this.errors = errors ?? [];
  }


}

export const fetchData = <TData, TVariables>(
  query: string,
  variables?: TVariables,
  options?: RequestInit['headers'],
): (() => Promise<TData>) => {
  var tenantId = getTenantIdentifier();

  if (query.includes("startTrial")) {
    tenantId ??= 'ariv';
  }

  return async () => {
    if (!tenantId) {
      throw new TenantMissingError();
    }

    const response = await fetch(`/${tenantId}/graphql`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept-Language': getFromLocalStorage('preferredLocale') ?? dayjs.locale(),
        'Unique-Client-Id': uniqueClientId,
        ...(options ?? {}),
      },
      body: JSON.stringify({
        query,
        variables,
      }),
    });

    const result = await response.json();

    const code = result.errors?.[0]?.extensions?.code;

    if (code === 'AUTH_NOT_AUTHENTICATED') {
      throw new ApiError(401, result.errors[0].message);
    } else if (code === 'AUTH_NOT_AUTHORIZED') {
      throw new ApiError(403, result.errors[0].message);
    }

    if (response.status < 200 || response.status >= 300) {
      throw new ApiError(response.status, response.statusText);
    }

    const resultQueryNames = Object.keys(result.data);
    for (const index in resultQueryNames) {
      const errors = result.data[resultQueryNames[index]]?.errors;

      if (errors) {
        const error = errors[0];
        throw new DomainError(error.message, errors);
      }
    }

    return result.data;
  };
};